// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root___NehA","left":"StickyBox_left__4WULI","right":"StickyBox_right__1s5DQ"};